import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600">耽美圈最火热的话题讨论，紧跟潮流不掉队</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {topicItems.map((topic) => (
            <div key={topic.id} className="group bg-background-100 rounded-xl md:rounded-2xl p-4 md:p-5 border border-background-200/70 hover:scale-[1.02] transition-all duration-200 cursor-pointer flex items-center justify-between">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading text-primary-500 text-lg">#{topic.id}</span>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-sm md:text-base text-foreground-900 truncate">{topic.name}</h3>
                  <div className="flex items-center gap-2 text-[10px] md:text-xs text-foreground-500">
                    <span className="flex items-center gap-0.5">
                      <i className="ri-fire-line w-3 h-3 flex items-center justify-center"></i>
                      {topic.heat}
                    </span>
                    <span className="flex items-center gap-0.5">
                      <i className="ri-chat-1-line w-3 h-3 flex items-center justify-center"></i>
                      {topic.posts}帖
                    </span>
                  </div>
                </div>
              </div>
              <span className={`text-[10px] md:text-xs px-2 py-1 rounded-full font-medium flex-shrink-0 ${
                topic.tag === '热门' ? 'bg-accent-100 text-accent-700' :
                topic.tag === '经典' ? 'bg-primary-100 text-primary-700' :
                topic.tag === '新晋' ? 'bg-secondary-100 text-secondary-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>{topic.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}